import React from "react";

const WelcomeSection = ({ user, center }) => {
  return (
    <div className="mb-8 flex justify-between items-start">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
            {console.log(user.center)}
          Welcome back, {user.full_name}
        </h1>

        <p className="text-gray-600 mt-1">
          {center?.name} ({center?.code}) • {center?.type}
        </p>

        <div className="flex items-center mt-2">
          <span
            className={`px-2 py-1 text-xs rounded-full ${
              center?.license?.class === "success"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {center?.license?.message}
          </span>

          <span className="text-xs text-gray-500 ml-2">
            {Math.round(center?.license?.days)} days remaining
          </span>
        </div>
      </div>

      <div
        className={`px-3 py-1 rounded-full text-sm ${
          center?.status === "active"
            ? "bg-green-100 text-green-800"
            : "bg-gray-100 text-gray-800"
        }`}
      >
        {center?.status}
      </div>
    </div>
  );
};

export default React.memo(WelcomeSection);